export class ChangeLessee {
  constructor({
    id = 0,
    orderID = 0,
    dealerID = 0,
    changeLesseeDetails = {},
    directDebit = {},
    formerCustomerID = 0,
    formerCustomerNo = null,
    newCustomerID = 0,
    guid = '00000000-0000-0000-0000-000000000000',
    status = '',
    services = '',
    formerCustomer = null,
    newCustomer = null,
    _lesseChangeGuidURL = '',
  } = {}) {
    this.id = id;
    this.orderID = orderID;
    this.dealerID = dealerID;
    this.changeLesseeDetails = changeLesseeDetails;
    this.directDebit = directDebit;
    this.formerCustomerID = formerCustomerID;
    this.formerCustomerNo = formerCustomerNo;
    this.newCustomerID = newCustomerID;
    this.guid = guid;
    this.dealerID = dealerID;
    this.status = status;
    this.services = services;
    this.formerCustomer = formerCustomer;
    this.newCustomer = newCustomer;
    this._lesseChangeGuidURL = _lesseChangeGuidURL;
  }
}

export function createChangeLessee(data) {
  return Object.freeze(new ChangeLessee(data));
}
